import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'bulkReportsStop'

export default () => (asyncAction(
  name,
  ReportsService.bulkReportsStop,
  { status: 'Stopped' }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/bulkReportsStop.js